export class LicenseDevice {

    private internalId: string;
    private active: boolean;
    private deviceName: string;
    private deviceTypeName: string;
    private lastConnection: number;
    private centerName: string;
    private deviceModel: string;

    constructor(internalId?: string,
                active?: boolean,
                deviceName?: string,
                deviceTypeName?: string,
                lastConnection?: number,
                centerName?: string,
                deviceModel?: string) {
                    this.internalId = internalId;
                    this.active = active;
                    this.deviceName = deviceName;
                    this.deviceTypeName = deviceTypeName;
                    this.lastConnection = lastConnection;
                    this.centerName = centerName;
                    this.deviceModel = deviceModel;
                }

    public get InternalId(): string {
        return this.internalId;
    }
    public get Active(): boolean {
        return this.active;
    }
    public get DeviceName(): string {
        return this.deviceName;
    }
    public get DeviceTypeName(): string {
        return this.deviceTypeName;
    }
    public get LastConnection(): number {
        return this.lastConnection;
    }
    public get CenterName(): string {
        return this.centerName;
    }
    public get DeviceModel(): string {
        return this.deviceModel;
    }

    public set InternalId(internalId: string) {
        this.internalId = internalId;
    }
    public set Active(active: boolean) {
        this.active = active;
    }
    public set DeviceName(deviceName: string) {
        this.deviceName = deviceName;
    }
    public set DeviceTypeName(deviceTypeName: string) {
        this.deviceTypeName = deviceTypeName;
    }
    public set LastConnection(lastConnection: number) {
        this.lastConnection = lastConnection;
    }
    public set CenterName(centerName: string) {
        this.centerName = centerName;
    }
    public set DeviceModel(deviceModel: string) {
        this.deviceModel = deviceModel;
    }
}
